/* Audio dei video testimonianza.
   I video partono muti (obbligatorio: se no il browser blocca l'autoplay).
   L'unico comando e' l'audio, come da regole THK. Attivandone uno, gli
   altri tornano muti: due voci sovrapposte non si capiscono.

   20/08/2026 — le due etichette per i lettori di schermo ("Attiva l'audio",
   "Togli l'audio") erano scritte qui dentro in italiano e restavano italiane
   in tutte le lingue. Adesso arrivano dal Liquid via window.CM_T. */
(function () {
  /* le frasi tradotte arrivano dal Liquid; il secondo argomento e' il ripiego */
  function T(chiave, ripiego) {
    return (window.CM_T && window.CM_T[chiave]) || ripiego;
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vt-audio]');
    if (!b) return;
    var clip = b.closest('.vt-clip');
    var v = clip && clip.querySelector('video');
    if (!v) return;

    if (v.muted) {
      document.querySelectorAll('.vt-clip video').forEach(function (altro) {
        if (altro !== v) { altro.muted = true; altro.closest('.vt-clip').classList.remove('con-audio'); }
      });
      v.muted = false;
      clip.classList.add('con-audio');
      b.setAttribute('aria-label', T('togliAudio', 'Togli l’audio'));
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    } else {
      v.muted = true;
      clip.classList.remove('con-audio');
      b.setAttribute('aria-label', T('attivaAudio', 'Attiva l’audio'));
    }
  });

  /* i video partono solo quando entrano in vista: non si scaricano tutti insieme */
  if ('IntersectionObserver' in window) {
    var os = new IntersectionObserver(function (voci) {
      voci.forEach(function (v) {
        var el = v.target;
        if (v.isIntersecting) { if (el.paused) { var p = el.play(); if (p && p.catch) p.catch(function () {}); } }
        else if (!el.paused && el.muted) { el.pause(); }
      });
    }, { threshold: 0.35 });
    document.querySelectorAll('.vt-clip video').forEach(function (v) { os.observe(v); });
  }
})();
